import { Box } from "@chakra-ui/react";
import { colors, Spacing } from "goi_common";
import { BaseStack } from "goi_common/src/design-system";
import { ReactNode } from "react";

import { Accent, FunnelCard, FunnelDivider, FunnelNoteBox } from "../components/CostFunnelUI";

/**
 * Step 2 - 조문객 수에 따른 총비용 차이.
 *
 * 50명 / 200명 비교표로 "비용 변동의 핵심 변수는 조문객 수"라는 점을 전달한다.
 * 캡슐에 오렌지 강조를 넣지 않는 건 특정 규모를 유도하지 않기 위한 디자인 의도다.
 */
export default function Step2GuestCostDiff() {
  return (
    <BaseStack width="100%">
      <Box as="h1" className="head_24_b" color={colors.gray900} css={{ textWrap: "pretty" }}>
        <Accent>조문객 수</Accent>에 따라
        <br />총 비용이 크게 달라져요
      </Box>

      <Spacing gap={12} />
      <Box className="body_14_r" color={colors.gray800}>
        조문객이 늘어나면 빈소 평수와 음식 주문량이 함께 올라가기 때문이에요.
      </Box>

      <Spacing gap={18} />
      <FunnelCard padding="20px 18px">
        <CompareRow>
          <Box display="flex" justifyContent="center">
            <Box
              as="span"
              className="subtitle_14_b"
              color={colors.gray700}
              padding="5px 14px"
              borderRadius="9999px"
              background={colors.gray100}
            >
              50명
            </Box>
          </Box>
          <Box />
          <Box display="flex" justifyContent="center">
            <Box
              as="span"
              className="subtitle_14_b"
              color={colors.gray700}
              padding="5px 14px"
              borderRadius="9999px"
              background={colors.gray100}
            >
              200명
            </Box>
          </Box>
        </CompareRow>

        <Box padding="14px 0">
          <FunnelDivider />
        </Box>

        <CompareRow>
          <Box className="subtitle_14_sb" color={colors.gray700} textAlign="center">
            소형 빈소
          </Box>
          <Arrow />
          <Box className="subtitle_14_b" color={colors.gray900} textAlign="center">
            큰 평형 필요
          </Box>
        </CompareRow>

        <Box padding="13px 0">
          <FunnelDivider color={colors.gray100} />
        </Box>

        <CompareRow>
          <Box className="subtitle_14_sb" color={colors.gray700} textAlign="center">
            음식비
            <br />약 150만원
          </Box>
          <Arrow />
          <Box className="subtitle_14_b" color={colors.gray900} textAlign="center">
            약 600만원
            <br />
            <span className="caption_12_b" style={{ color: colors.orange750 }}>
              (+450)
            </span>
          </Box>
        </CompareRow>
      </FunnelCard>

      <Spacing gap={18} />
      <FunnelNoteBox label="참고하세요">
        제단꽃은 조문객 수와 무관하게 등급 선택에 따라 금액이 정해져요.
      </FunnelNoteBox>
    </BaseStack>
  );
}

/** 좌 / 화살표 / 우 3열. 좁은 기기에서도 줄바꿈 없이 축소되도록 가운데 칸만 고정폭. */
function CompareRow({ children }: { children: ReactNode }) {
  return (
    <Box display="grid" gridTemplateColumns="1fr 22px 1fr" alignItems="center" gap="8px">
      {children}
    </Box>
  );
}

function Arrow() {
  return (
    <Box className="subtitle_14_b" color={colors.orange650} textAlign="center">
      →
    </Box>
  );
}
